"use client";

import React, { useState } from "react";

interface RatingProps extends React.HTMLAttributes<HTMLDivElement> {
  maxStars?: number;
  onRatingChange?: (rating: number) => void;
  value?: number;
}

const Rating: React.FC<RatingProps> = ({
  maxStars = 5,
  onRatingChange,
  value,
}) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseEnter = (index: number) => {
    if (value === undefined) {
      setHoverRating(index);
    }
  };

  const handleMouseLeave = () => {
    if (value === undefined) {
      setHoverRating(0);
    }
  };

  const handleClick = (index: number) => {
    if (value === undefined) {
      setRating(index);
      if (onRatingChange) {
        onRatingChange(index);
      }
    }
  };

  const renderStars = () => {
    const stars = [];
    const displayRating = value !== undefined ? value : hoverRating || rating;
    for (let i = 1; i <= maxStars; i++) {
      const isActive = i <= displayRating;
      stars.push(
        <div
          key={i}
          className="rating-star"
          onMouseEnter={() => handleMouseEnter(i)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(i)}
          style={{ cursor: value === undefined ? "pointer" : "default" }}
        >
          <img
            src={isActive ? "/images/Star.svg" : "/images/star-disabled.svg"}
            alt={`Star ${i}`}
            width={17}
            height={17}
          />
        </div>
      );
    }
    return stars;
  };

  return <div className="rating-stars-block">{renderStars()}</div>;
};

export default Rating;
